import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/3nmxk8rv_vaikunta-media-Main-Logo-White.png" 
              alt="Vaikuntha Media" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              Building Meaning. Amplifying Impact. Delivering Solutions.
            </p>
            <p className="footer-description">
              Multidisciplinary agency transforming fragmented messaging into clear, 
              responsible, brand-centric narratives.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <nav className="footer-links">
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/team" className="footer-link">Team</Link>
              <Link to="/partnerships" className="footer-link">Partners</Link>
              <Link to="/blog" className="footer-link">Insights</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-heading">Services</h3>
            <nav className="footer-links">
              <span className="footer-link">Media & Marketing</span>
              <span className="footer-link">Communication & Content</span>
              <span className="footer-link">Branding & PR</span>
              <span className="footer-link">Digital Solutions</span>
              <span className="footer-link">AI Consulting</span>
              <span className="footer-link">LinkedIn Sales Navigation</span>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Get In Touch</h3>
            <div className="footer-contact">
              <a href="mailto:connect@vaikunthamedia.com" className="footer-contact-item">
                <Mail size={18} />
                <span>connect@vaikunthamedia.com</span>
              </a>
              <a href="tel:+918779638170" className="footer-contact-item">
                <Phone size={18} />
                <span>+91 877 963 8170</span>
              </a>
              <a href="https://www.vaikunthamedia.com" className="footer-contact-item" target="_blank" rel="noopener noreferrer">
                <Globe size={18} />
                <span>www.vaikunthamedia.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 Vaikuntha Media. All rights reserved. Founded 2018.
          </p>
          <div className="footer-bottom-links">
            <span className="footer-bottom-link">Privacy Policy</span>
            <span className="footer-divider">|</span>
            <span className="footer-bottom-link">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
